module.exports = __webpack_public_path__ + "static/media/sad_emoji.193de74d.svg";